import { render, staticRenderFns } from "./TariffIntegrationsTable.vue?vue&type=template&id=10021fcb&scoped=true"
import script from "./TariffIntegrationsTable.vue?vue&type=script&lang=ts"
export * from "./TariffIntegrationsTable.vue?vue&type=script&lang=ts"
import style0 from "./TariffIntegrationsTable.vue?vue&type=style&index=0&id=10021fcb&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10021fcb",
  null
  
)

export default component.exports